import { css } from '@/styled-system/css';

export const dropdownHeaderStyles = css.raw({
  'flexGrow': 0,
  'flexShrink': 0,
  'flexBasis': 'auto',

  '& > [data-c11n-component="Dropdown.Heading"]': {
    borderStartStartRadius: 'obj.soft',
    borderStartEndRadius: 'obj.soft',
  },
});
